// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e8a86c32","239":"410343a3","453":"6f66468a","455":"a4ec3021"}[chunkId] + ".chunk.js";
};